<p data-testid="access-denied">{{ 'access-denied' | translate }}</p>
